/**
 * Globally pre-load all icons.
 * This lets us use the SVG icons anywhere we like, without loading artifacts in certain browsers.
 * TODO - colour variations of icons can be removed. Use fill parameter instead.
 */
import Vue from "vue";

// SVG icons (Mainly Google Material Icons)
import svgAddCircleFilled from "@/components/svg/svgAddCircleFilled.vue";
import svgAddCircleOutline from "@/components/svg/svgAddCircleOutline.vue";
// import svgAnonymousApproved from "@/components/svg/svgAnonymousApproved.vue";
// import svgAnonymousUnapproved from "@/components/svg/svgAnonymousUnapproved.vue";
import svgArrowDown from "@/components/svg/svgArrowDown.vue";
import svgArrowRight from "@/components/svg/svgArrowRight.vue";
import svgBatteryFull from "@/components/svg/svgBatteryFull.vue";
import svgBatteryEmpty from "@/components/svg/svgBatteryEmpty.vue";
import svgBookmark from "@/components/svg/svgBookmark.vue";
import svgBookmarkOutline from "@/components/svg/svgBookmarkOutline.vue";
import svgCancel from "@/components/svg/svgCancel.vue";
import svgCancelCircleFilled from "@/components/svg/svgCancelCircleFilled.vue";
import svgCancelCircleOutline from "@/components/svg/svgCancelCircleOutline.vue";
import svgCheck from "@/components/svg/svgCheck.vue";
import svgCheckCircleFilled from "@/components/svg/svgCheckCircleFilled.vue";
import svgCheckCircleOutline from "@/components/svg/svgCheckCircleOutline.vue";
import svgCheckCircleFilledGreen from "@/components/svg/svgCheckCircleFilledGreen.vue";
import svgCheckCircleOutlineGreen from "@/components/svg/svgCheckCircleOutlineGreen.vue";
import svgClose from "@/components/svg/svgClose.vue";
import svgComments from "@/components/svg/svgComments.vue";
import svgCommentsOff from "@/components/svg/svgCommentsOff.vue";
import svgCommentsOn from "@/components/svg/svgCommentsOn.vue";
import svgDeleteFilled from "@/components/svg/svgDeleteFilled.vue";
import svgDeleteOutline from "@/components/svg/svgDeleteOutline.vue";
// import svgDownload from "@/components/svg/svgDownload.vue";
import svgDragIndicator from "@/components/svg/svgDragIndicator.vue";
import svgEditFilled from "@/components/svg/svgEditFilled.vue";
import svgEditOutline from "@/components/svg/svgEditOutline.vue";
import svgErrorFilled from "@/components/svg/svgErrorFilled.vue";
import svgErrorOutline from "@/components/svg/svgErrorOutline.vue";
import svgErrorFilledRed from "@/components/svg/svgErrorFilledRed.vue";
// import svgErrorOutlineRed from "@/components/svg/svgErrorOutlineRed.vue";
import svgForumPublic from "@/components/svg/svgForumPublic.vue";
import svgForumPrivate from "@/components/svg/svgForumPrivate.vue";
import svgHelpFilled from "@/components/svg/svgHelpFilled.vue";
import svgHelpOutline from "@/components/svg/svgHelpOutline.vue";
import svgInfo from "@/components/svg/svgInfo.vue";
import svgList from "@/components/svg/svgList.vue";
// import svgLockClosed from "@/components/svg/svgLockClosed.vue";
// import svgLockClosedFilled from "@/components/svg/svgLockClosedFilled.vue";
// import svgLockOpen from "@/components/svg/svgLockOpen.vue";
// import svgLockOpenFilled from "@/components/svg/svgLockOpenFilled.vue";
import svgMedals from "@/components/svg/svgMedals.vue";
import svgNotice from "@/components/svg/svgNotice.vue";
import svgPublished from "@/components/svg/svgPublished.vue";
// import svgReactionAgree from "@/components/svg/svgReactionAgree.vue";
// import svgReactionAgreeSelected from "@/components/svg/svgReactionAgreeSelected.vue";
import svgReactionGoodIdea from "@/components/svg/svgReactionGoodIdea.vue";
import svgReactionGoodIdeaSelected from "@/components/svg/svgReactionGoodIdeaSelected.vue";
// import svgReactionInteresting from "@/components/svg/svgReactionInteresting.vue";
// import svgReactionInterestingSelected from "@/components/svg/svgReactionInterestingSelected.vue";
import svgReactionLike from "@/components/svg/svgReactionLike.vue";
import svgReactionLikeSelected from "@/components/svg/svgReactionLikeSelected.vue";
// import svgReactionWellDone from "@/components/svg/svgReactionWellDone.vue";
// import svgReactionWellDoneSelected from "@/components/svg/svgReactionWellDoneSelected.vue";
import svgShared from "@/components/svg/svgShared.vue";
import svgStar from "@/components/svg/svgStar.vue";
import svgSticky from "@/components/svg/svgSticky.vue";
import svgStickyGrey from "@/components/svg/svgStickyGrey.vue";
import svgStickyOutline from "@/components/svg/svgStickyOutline.vue";
import svgStickyOutlineGrey from "@/components/svg/svgStickyOutlineGrey.vue";
import svgUnpublished from "@/components/svg/svgUnpublished.vue";
import svgUnshared from "@/components/svg/svgUnshared.vue";
import svgVerifiable from "@/components/svg/svgVerifiable.vue";

Vue.component("svgAddCircleFilled", svgAddCircleFilled);
Vue.component("svgAddCircleOutline", svgAddCircleOutline);
// Vue.component("svgAnonymousApproved", svgAnonymousApproved);
// Vue.component("svgAnonymousUnapproved", svgAnonymousUnapproved);
Vue.component("svgArrowDown", svgArrowDown);
Vue.component("svgArrowRight", svgArrowRight);
Vue.component("svgBatteryFull", svgBatteryFull);
Vue.component("svgBatteryEmpty", svgBatteryEmpty);
Vue.component("svgBookmark", svgBookmark);
Vue.component("svgBookmarkOutline", svgBookmarkOutline);
Vue.component("svgCancel", svgCancel);
Vue.component("svgCancelCircleFilled", svgCancelCircleFilled);
Vue.component("svgCancelCircleOutline", svgCancelCircleOutline);
Vue.component("svgCheck", svgCheck);
Vue.component("svgCheckCircleFilled", svgCheckCircleFilled);
Vue.component("svgCheckCircleOutline", svgCheckCircleOutline);
Vue.component("svgCheckCircleFilledGreen", svgCheckCircleFilledGreen);
Vue.component("svgCheckCircleOutlineGreen", svgCheckCircleOutlineGreen);
Vue.component("svgClose", svgClose);
Vue.component("svgComments", svgComments);
Vue.component("svgCommentsOff", svgCommentsOff);
Vue.component("svgCommentsOn", svgCommentsOn);
Vue.component("svgDeleteFilled", svgDeleteFilled);
Vue.component("svgDeleteOutline", svgDeleteOutline);
// Vue.component("svgDownload", svgDownload);
Vue.component("svgDragIndicator", svgDragIndicator);
Vue.component("svgEditFilled", svgEditFilled);
Vue.component("svgEditOutline", svgEditOutline);
Vue.component("svgErrorFilled", svgErrorFilled);
Vue.component("svgErrorOutline", svgErrorOutline);
Vue.component("svgErrorFilledRed", svgErrorFilledRed);
// Vue.component("svgErrorOutlineRed", svgErrorOutlineRed);
Vue.component("svgForumPublic", svgForumPublic);
Vue.component("svgForumPrivate", svgForumPrivate);
Vue.component("svgHelpFilled", svgHelpFilled);
Vue.component("svgHelpOutline", svgHelpOutline);
Vue.component("svgInfo", svgInfo);
Vue.component("svgList", svgList);
// Vue.component("svgLockClosed", svgLockClosed);
// Vue.component("svgLockClosedFilled", svgLockClosedFilled);
// Vue.component("svgLockOpen", svgLockOpen);
// Vue.component("svgLockOpenFilled", svgLockOpenFilled);
Vue.component("svgMedals", svgMedals);
Vue.component("svgNotice", svgNotice);
Vue.component("svgPublished", svgPublished);
// Vue.component("svgReactionAgree", svgReactionAgree);
// Vue.component("svgReactionAgreeSelected", svgReactionAgreeSelected);
Vue.component("svgReactionGoodIdea", svgReactionGoodIdea);
Vue.component("svgReactionGoodIdeaSelected", svgReactionGoodIdeaSelected);
// Vue.component("svgReactionInteresting", svgReactionInteresting);
// Vue.component("svgReactionInterestingSelected", svgReactionInterestingSelected);
Vue.component("svgReactionLike", svgReactionLike);
Vue.component("svgReactionLikeSelected", svgReactionLikeSelected);
// Vue.component("svgReactionWellDone", svgReactionWellDone);
// Vue.component("svgReactionWellDoneSelected", svgReactionWellDoneSelected);
Vue.component("svgShared", svgShared);
Vue.component("svgStar", svgStar);
Vue.component("svgSticky", svgSticky);
Vue.component("svgStickyGrey", svgStickyGrey);
Vue.component("svgStickyOutline", svgStickyOutline);
Vue.component("svgStickyOutlineGrey", svgStickyOutlineGrey);
Vue.component("svgUnpublished", svgUnpublished);
Vue.component("svgUnshared", svgUnshared);
Vue.component("svgVerifiable", svgVerifiable);
